export default defineNuxtPlugin((nuxtApp) => {
    if (process.client) {
        import('bootstrap/dist/js/bootstrap.bundle.min.js')
    }
})
